import { useEffect, useState } from 'react';
export const useCountdown = (deltaCountdown) => {
    const countdownDate = new Date(deltaCountdown).getTime();
    const [countdown, setCountdown] = useState(900610000); // 10 days, 10 hours, 10 minutes, 10 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown(countdownDate - new Date().getTime());
        }, 1000);
        return () => clearInterval(interval);
    }, [countdownDate, deltaCountdown]);
    return getReturnValues(countdown);
};
const getReturnValues = (countdown) => {
    // calculate time left
    const days = Math.max(Math.floor(countdown / (1000 * 60 * 60 * 24)), 0);
    const hours = Math.max(Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0);
    const minutes = Math.max(Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60)), 0);
    const seconds = Math.max(Math.floor((countdown % (1000 * 60)) / 1000), 0);
    return [days, hours, minutes, seconds];
};
//# sourceMappingURL=useCountdown.js.map